import { useState } from 'react';

const useStepper = (totalSteps: number): [number, () => void] => {
  const [step, setStep] = useState(0);

  const isLast = step == totalSteps - 1;

  const next = () => {
    if (!isLast) {
      setStep(step + 1);
    }
  };

  return [step, next];
};

export default useStepper;
